/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_PortabilityInputs */

const en_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to data portability`)
};

const de_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht auf Datenübertragbarkeit`)
};

const fr_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit à la portabilité des données`)
};

const es_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho a la portabilidad de datos`)
};

const it_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto alla portabilità dei dati`)
};

const nl_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht op gegevensoverdraagbaarheid`)
};

const pl_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do przenoszenia danych`)
};

const fi_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus tietojen siirrettävyyteen`)
};

const da_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til dataportabilitet`)
};

const sv_privacy_rights_item_portability = /** @type {(inputs: Privacy_Rights_Item_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt till dataportabilitet`)
};

/**
* | output |
* | --- |
* | "Right to data portability" |
*
* @param {Privacy_Rights_Item_PortabilityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_portability = /** @type {((inputs?: Privacy_Rights_Item_PortabilityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_PortabilityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_portability(inputs)
	if (locale === "fr") return fr_privacy_rights_item_portability(inputs)
	if (locale === "es") return es_privacy_rights_item_portability(inputs)
	if (locale === "it") return it_privacy_rights_item_portability(inputs)
	if (locale === "nl") return nl_privacy_rights_item_portability(inputs)
	if (locale === "pl") return pl_privacy_rights_item_portability(inputs)
	if (locale === "fi") return fi_privacy_rights_item_portability(inputs)
	if (locale === "da") return da_privacy_rights_item_portability(inputs)
	if (locale === "sv") return sv_privacy_rights_item_portability(inputs)
	return en_privacy_rights_item_portability(inputs)
});